<div class="login-container">
  <div class="login-box">
    <div class="logo">
      <img src="assets/images/excuela-logo.svg" alt="Excuela Logo" class="logo-image">
    </div>

    <p class="login-title">Iniciar Sesión</p>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="on" name="loginForm">
      <div class="form-field">
        <input 
          type="email"
          formControlName="email"
          placeholder="correo@excuela.com"
          autocomplete="email"
          name="email"
          class="form-input">
        <div *appFormFieldError="loginForm.get('email'); let errors" class="error-message-small">
          @for (error of errors; track error) {
            <div>{{ error }}</div>
          }
        </div>
      </div>

      <div class="form-field">
        <div class="password-input">
          <input 
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            placeholder="••••••••"
            autocomplete="password"
            name="password"
            class="form-input">
          <button 
            type="button" 
            class="toggle-password"
            (click)="togglePasswordVisibility()">
            <i class="fas" [class.fa-eye]="hidePassword" [class.fa-eye-slash]="!hidePassword"></i>
          </button>
        </div>
        <div *appFormFieldError="loginForm.get('password'); let errors" class="error-message-small">
          @for (error of errors; track error) {
            <div>{{ error }}</div>
          }
        </div>
      </div>

      <button type="submit" class="submit-button" [disabled]="loginForm.invalid || submitting">
        @if (submitting) {
          <div class="loader-container">
            <div class="spinner"></div>
            <span>Iniciando sesión...</span>
          </div>
        } @else {
          Iniciar sesion
        }
      </button>

      <div class="forgot-password">
        <a href="/recover-password" class="forgot-password-link">¿Olvidaste tu contraseña?</a>
      </div>
    </form>
  </div>
</div> 